import { AbstractSliderChild } from "./AbstractSliderChild.js";
class SliderCount extends AbstractSliderChild {
  /**
   * Config.
   */
  static config = {
    name: "SliderCount",
    refs: ["current"]
  };
  /**
   * Update the current counter indicator.
   * @param   {number} index The new active index.
   * @returns {void}
   */
  update(index) {
    this.$refs.current.innerHTML = `${index + 1}`;
  }
}
export {
  SliderCount
};
//# sourceMappingURL=SliderCount.js.map
